import React, { Component } from 'react';
import AOS from 'aos';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMagic, faTheaterMasks, faDove } from '@fortawesome/free-solid-svg-icons'
import { faReact, faJs, faAdobe, faSketch, faCodepen, faFacebook, faBloggerB, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom';

 
import '../../node_modules/aos/dist/aos.css'
import '../css/about.scss'

import performance from '../images/work/performance.jpg'

class About extends Component {

  componentDidMount(){
    window.scrollTo({'top':0});

    AOS.init({
      duration : 1000
    });

    this.randomText();

  }

  randomText(){

    const randomEl = document.querySelectorAll('.random_text');

    Array.prototype.forEach.call(randomEl, (el, i) => {
        let theLetters = "abcdefghijklmnopqrstuvwxyz#%&^+=-"; //customize letters cycle 
        let ctnt = el.getAttribute('data-text');
        let speed = 10; // ms per frame
        let increment = 10; // frames per step. Must be >2

        let clen = ctnt.length;
        let si = 0;
        let stri = 0;
        let block = "";
        let fixed = "";

        //Call self x times, whole function wrapped in setTimeout
        (function rustle(i) {
          setTimeout(function () {
            if (--i) { rustle(i); }
            nextFrame(i); 
            si = si + 1;
          }, speed);
        })(clen * increment + 1);

        const nextFrame = (pos) =>{
          for (var i = 0; i < clen - stri; i++) {
            //Random number
            var num = Math.floor(theLetters.length * Math.random());
            //Get random letter
            var letter = theLetters.charAt(num);
            block = block + letter;
          }
          if (si == (increment - 1)) {
            stri++;
          }
          if (si == increment) {
            // Add a letter; 
            // every speed*10 ms
            fixed = fixed + ctnt.charAt(stri - 1);
            si = 0;
          }
          el.innerHTML = fixed + block;
          block = "";
        }
    });

  }

  render() {


    return (
      <React.Fragment>

        <div id="about">


          <div className="section_copy">
              <p className="cate">About</p>
              <p className="desc">
                변검과 마술의 콜라보레이션<br/>
                변검 마술쇼의 대표브랜드 차이나매직
              </p>
          </div>



          <section className="intro" data-aos="fade-up">

            {/* <h2>Chinamagic</h2>
            <div className="info" >

              <p className="job">변검과 마술의 환상적인 콜라보레이션</p>
            </div> */}

            <p className="m_copy random_text" data-text="Magic &amp; 变脸" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease">
              Magic &amp; 变脸 <span className="mbr"></span>
            </p>

            {/* <div className="abdesc" data-aos="fade-up">
                <p data-aos="fade-up" data-aos-deplay="1000">
                변검과 마술의 콜라보레이션<br/>
                변검 마술쇼의 대표브랜드 차이나매직
                </p>
            </div> */}

            <div className="best" data-aos="fade-right">
              <img src={performance} alt=""/>
            </div>

            <div className="desc_wrap">
              <p className="desc">
                    변검은 관객들이 보는 앞에서 순식간에 얼굴을 바꾸는 중국을 대표하는 전통극으로 한 두명의 수제자에게만 전수되고 있을 정도로 중국의 국보로 불리는 환상적인 공연입니다. 중국 고유의 음악과 특유의 의상,행위 예술적인 표현으로 마치 중국에 있는 느낌을 받으실 수 있습니다. </p>

              <p className="desc">
              차이나매직은 2008년 설립되었으며, 수년간 쌓아온 경험과 노하우를 바탕으로 
              관객과 소통하는 다양한 참여형 마술쇼와 함께 순식간에 가면을 바꾸는 중국을 대표하는 전통극인 변검쇼
              가 어우러진 환상적인 공연을 진행해오고 있습니다.
              </p>

              <p className="desc">지역축제 · 결혼 · 돌잔치 · 축하공연 등 다수의 국내외 공연으로 명성을 쌓아온 차이나매직은 KBS2 TV 드라마 방송출연 등 다년간의 경험으로 변검쇼의 대표브랜드로 계속해서 성장해 나가고 있습니다.</p>
            </div>

            <div className="btn_wrap">
              <Link to="/Work">
                <button className="action">공연사진 보러가기</button>
              </Link>
            </div>

          </section>
          

        
          <section data-aos="fade-up" className="skill">
            <h2>Performance</h2>

            <ul className="list_type1">
              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">변검</div>
                <div className="type">
                  <span>중국 국보 전통 가면술</span>
                </div>
                <div className="detail">
                  <span><FontAwesomeIcon icon={faTheaterMasks} /> 변검 퍼포먼스</span>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="100">
                <div className="cate">마술</div>
                <div className="type">
                  <span>다양한 스테이지 마술공연</span>
                </div>
                <div className="detail">
                  <span><FontAwesomeIcon icon={faMagic} /> 다양한 마술도구 보유</span>
                  <span><FontAwesomeIcon icon={faDove} /> 비둘기 매직퍼포먼스</span>
                </div>
              </li>
            </ul>

            {/* <div className="btn_wrap">
              <Link to="/">
                <button className="action">대표 공연영상 보러가기</button>
              </Link>
            </div> */}

          </section>


        

          <section data-aos="fade-up" className="experience">
            <h2>Experience</h2>

            <div className="exp_data">
              <p data-aos="fade-up">
                  <span data-aos="fade-right">11</span>th year from 2008
              </p>

              <p data-aos="fade-up">
                  수년간 쌓아온 경험과 노하우를 바탕으로 환상적인 공연을 진행해오고 있습니다.
              </p>
            </div>

            <ul className="list_type1">
              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">2019 ~</div>
                <div className="detail">
                  <ul>
                      <li>창평 전통시장</li>
                      <li>금호타이어 가족 Festival</li>
                      <li>국립제주 박물관</li>
                      <li>코오롱스포츠와 함께하는 옐로우 시티 장성 건강걷기대회</li>
                      <li>城見櫓</li>
                      <li>原西公民館</li>
                      <li>早良区脇山公民館</li>
                      <li>Prime Cafe プライムカフェ</li>
                      <li>Camellia Line</li>
                      <li>화순운주문화축제</li>
                      <li>군산 예술의 전당</li>
                      <li>진도노인복지관</li>
                      <li>담양 대나무축제</li>
                      <li>약산 진달래 흑염소 축제</li>
                      <li>광산구 통장 한마음축제</li>
                      <li>경기도 새마을회장단 연찬회</li>
                      <li>보성다비치콘도</li>
                      <li>광주시립미술관</li>
                      <li>소화유치원</li>
                    </ul>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">2015</div>
                <div className="detail">
                  <ul>
                    <li>한중문화교류 페스티벌</li>
                    <li>완도 장보고 수산물 축제</li>
                    <li>샘고을 시장 야한 야시장</li>
                    <li>장흥 여자중학교</li>
                    <li>장흥 공공 도서관</li>
                    <li>내 나라 여행박람회</li>
                    <li>땅끝 해넘이 해맞이 축제</li>
                    <li>진남문예회관</li>
                    <li>정읍 연지 유치원</li>
                    <li>완주 곶감축제</li>
                    <li>영광군 축산인 한마음대회</li>
                    <li>광주장애인 송년행사</li>
                    <li>무안군 보건소</li>
                    <li>전라남도 사회적 경제인 한마당</li>
                    <li>광양시립중마 도서관</li>
                    <li>추자도 참굴비 대축제</li>
                    <li>대한민국상이군경회 전라남도지부</li>
                    <li>적벽 문화제</li>
                    <li>전남지역 장애인복지관 종사자 어울마당</li>
                    <li>MG 호남 새마을금고孝효 콘서트</li>
                    <li>마량미항토요음악회</li>
                    <li>광양시립도서관</li>
                    <li>장성군민의 날 기념 전야제 축하쇼</li>
                    <li>강진오감통</li>
                    <li>영광 백수해안도로 노을축제</li>
                    <li>울산 북구 기적 의 도서관</li>
                    <li>창평 전통시장</li>
                    <li>금호타이어 가족 Festival</li>
                    <li>국립제주 박물관</li>
                    <li>코오롱스포츠와 함께하는 옐로우 시티 장성 건강걷기대회</li>
                    <li>城見櫓</li>
                    <li>原西公民館</li>
                    <li>早良区脇山公民館</li>
                    <li>Prime Cafe プライムカフェ</li>
                    <li>Camellia Line</li>
                    <li>화순운주문화축제</li>
                    <li>군산 예술의 전당</li>
                    <li>진도노인복지관</li>
                    <li>담양 대나무축제</li>
                    <li>약산 진달래 흑염소 축제</li>
                    <li>광산구 통장 한마음축제</li>
                    <li>경기도 새마을회장단 연찬회</li>
                    <li>보성다비치콘도</li>
                    <li>광주시립미술관</li>
                    <li>소화유치원</li>
                  </ul>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">2014</div>
                <div className="detail">
                  <ul>
                    <li>보성다비치콘도</li>
                    <li>광주시립미술관</li>
                    <li>소화유치원</li>
                    <li>현대중공업 방어진 애향회2014정기 총회 및 송년의 밤</li>
                    <li>완주흑곶감축제</li>
                    <li>오뚜기 광주 1지점 송년의 밤</li>
                    <li>거제 삼성호텔</li>
                    <li>ENSCO CHRISTMAS DINNER</li>
                    <li>청계면 경로효도 큰 잔치</li>
                    <li>중국 문화제</li>
                    <li>장애인 행복 나눔 축제</li>
                    <li>나주목사고을시장</li>
                    <li>九州国際フェスティバルin 日田</li>
                    <li>정남진 토요시장</li>
                    <li>주월중학교</li>
                    <li>노안 농협 여성조합원 교육</li>
                    <li>주민과 함께하는 창덕 가을음악회</li>
                    <li>이서 적벽 개방식 및 제29회 적벽 문화제</li>
                    <li>군내면 어르신 위안잔치</li>
                    <li>문화의달</li>
                    <li>광주 패밀리랜드</li>
                    <li>광주세계김치문화축제</li>
                    <li>노인의 날 기념 남면 경로위안잔치</li>
                    <li>노대 송화촌 난장 음악회</li>
                    <li>장평 명품 귀족호도 축제</li>
                    <li>공자학원의 날 10주년 중국 문화축제</li>
                    <li>오산 초등학교</li>
                    <li>전남도청 비둘기 어린이집 가을 가족음악회</li>
                    <li>장애인 행복 스타 경연 대회</li>
                    <li>전남학생 스포츠 문화축제</li>
                    <li>광주문화재단</li>
                    <li>남평 읍민 한가위 노래자랑</li>
                    <li>광주비엔날레</li>
                    <li>한여름밤의 도고 노을 콘서트</li>
                    <li>행복 나눔 백수 어르신孝대잔치</li>
                    <li>아우라 뷰티 칼리지 WORKSHOP</li>
                    <li>담양 대나무축제</li>
                    <li>너와 나의 권리 이야기 광산구 드림스타트</li>
                    <li>소통으로 함께 웃는 우리 가족 광산구 드림스타트</li>
                    <li>롯데마트 문화센터 목포점</li>
                    <li>알펜시아 웨딩홀</li>
                    <li>CJ오쇼핑</li>
                    <li>나주목사고을시장</li>
                    <li>롯데마트 문화센터 익산점</li>
                    <li>롯데마트 문화센터 전주점</li>
                    <li>진남유치원</li>
                    <li>이마트 문화센터 군산점</li>
                    <li>이마트 문화센터 익산점</li>
                    <li>차이나 매직 콘서트</li>
                  </ul>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">2013</div>
                <div className="detail">
                  <ul>
                    <li>광주시립미술관</li>
                    <li>가족 한마당 잔치 및 후원인의 날 행사 정읍시 드림스타트센터</li>
                    <li>화순군 청소년中國語말하기 대회 축제</li>
                    <li>광주과학기술원 의료시스템학과 송년회</li>
                    <li>한동 축제 임자 중고등학교</li>
                    <li>광주장애인 송년행사</li>
                    <li>현대기아차 협력회 광주 분회 회원사와 함께하는 2013년 더불어樂락 송년잔치</li>
                    <li>롯데마트 문화센터 여수점</li>
                    <li>남평중학교 총동문회 송년회</li>
                    <li>무안군 보건소</li>
                    <li>광주 인화학교 총동문회 기금 마련을 위한 사랑의 일일찻집</li>
                    <li>롯데마트 문화센터 상무점</li>
                    <li>롯데마트 문화센터 월드컵점</li>
                    <li>나주 봉황중학교</li>
                    <li>전라남도 새마을지도자 대회</li>
                    <li>P&amp;J 웨딩홀</li>
                    <li>대전광역시 서구보건소</li>
                    <li>정읍시 청소년문화존 우리도 슈퍼스타 청소년 동아리 경연마당</li>
                    <li>라페스타 웨딩홀</li>
                    <li>월봉 중학교</li>
                    <li>광주 북구 일곡 도서관</li>
                    <li>봉선시장 활성화 문화이벤트 봉선 노들 음악회</li>
                    <li>각화 문화의 집 다락多樂힐링 음악회</li>
                    <li>솔로탈출 정남진 장흥에서 반쪽을 찾습니다</li>
                    <li>국립전주 박물관</li>
                    <li>전주비빔밥축제</li>
                    <li>신태인 JC와 함께하는 정읍시 청소년 한마당 잔치</li>
                    <li>빛고을 청소년문화존</li>
                    <li>정읍 공립유치원 온 가족사랑 나눔 축제</li>
                    <li>중국 문화축제</li>
                    <li>세한대학교 공자아카데미</li>
                    <li>정채봉 동화잔치</li>
                    <li>홍선생미술 회원 전시회</li>
                    <li>안동국제탈춤페스티벌</li>
                    <li>F1 성공 개최 원도심 로데오광장을 찾아서 찾아가는 예술 공연</li>
                    <li>일본 후쿠오카 현 오노조시 한일 청소년문화교류</li>
                    <li>大野城まどかぴあ</li>
                    <li>광주비엔날레</li>
                    <li>영광군 청소년문화센터 토요프로그램 마술교실 발표회 및 수료식</li>
                    <li>한중 전통문화교류</li>
                    <li>제44차 전남지구 JC 회원대회 제35회 남도 청년대상 시상</li>
                    <li>하당 성당</li>
                    <li>이마트 문화센터 광산점</li>
                    <li>이마트 문화센터 상무점</li>
                    <li>천주교 금당 성당</li>
                    <li>광주가톨릭 평생교육원</li>
                    <li>강진청자축제</li>
                    <li>광주백운초등학교</li>
                    <li>무지개다리 사업 우리 누리 지역민 이주민 문화예술만남의 장</li>
                    <li>전남대학교병원 아토피피부염 학교</li>
                    <li>팔봉산 감자축제</li>
                    <li>광주문화재단</li>
                    <li>남평중학교 총동문회 제4회 정기총회</li>
                    <li>이마트 문화센터 군산점</li>
                    <li>이마트 문화센터 익산점</li>
                  </ul>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="0">
                <div className="cate">~ 2008</div>
                <div className="detail">
                  <ul>
                    <li>그랜드 하얏트 인천</li>
                    <li>프레지던트호텔</li>
                    <li>서울가든호텔</li>
                    <li>삼성화재 유성연수원</li>
                    <li>신안비치호텔</li>
                    <li>호텔 프라도</li>
                    <li>광주장애인 송년행사</li>
                    <li>서구청소년문화존컬러풀풀colorfulpool</li>
                    <li>찾아가는 영해관광시장 홍보존</li>
                    <li>청계면 청년회 경로효도 큰 잔치</li>
                    <li>해남군 청소년문화존</li>
                    <li>대한민국 삼채 축제</li>
                    <li>신안 뻘낙지 축제</li>
                    <li>목포시 종합사회복지관</li>
                    <li>군산 진포중학교</li>
                    <li>광주대학교 유아교육과</li>
                    <li>삼서면 민의 날 한마음축제</li>
                    <li>동아여자중학교</li>
                    <li>마포나루 새우젓축제</li>
                    <li>전주비빔밥축제</li>
                    <li>중국 문화축제</li>
                    <li>광주세계김치문화축제</li>
                    <li>외국인 근로자 어울림 한마당</li>
                    <li>초당대학교</li>
                    <li>천년의 빛 영광 노인의 날 기념 어르신 구구 팔팔 대 축제</li>
                    <li>광주세계아리랑축전</li>
                    <li>광주비엔날레</li>
                    <li>롯데시네마 수완 중국 변검 마술쇼</li>
                    <li>금산인삼축제</li>
                    <li>중앙로 지하상가 벼리 누리 페스티벌</li>
                    <li>하동축협과 함께하는 사랑의 콘서트</li>
                    <li>영광군 청소년문화센터 개관</li>
                    <li>이마트 문화센터 익산점</li>
                    <li>이마트 문화센터 군산점</li>
                    <li>팔봉산 감자축제</li>
                    <li>롯데마트 문화센터 여수점</li>
                    <li>영광 농협 하나로마트 경품 대잔치</li>
                    <li>롯데마트 문화센터 월드컵점</li>
                    <li>롯데마트 문화센터 수완점</li>
                    <li>목포과학대학교</li>
                    <li>시민종합사회복지관</li>
                    <li>부산광역시 정신보건센터 정신건강의 날 기념행사 The 울림&amp;두드림 체육대회</li>
                    <li>영산포 홍어축제</li>
                    <li>리솜오션캐슬</li>
                    <li>광주지방국세청</li>
                    <li>서해 대학교</li>
                    <li>해오름유치원</li>
                    <li>곤지암리조트</li>
                    <li>롯데마트 문화센터 상무점</li>
                    <li>무안 현경 중학교</li>
                    <li>아모레퍼시픽</li>
                    <li>광주신세계</li>
                    <li>한국야쿠르트</li>
                  </ul>
                </div>
              </li>

            </ul>

            <div className="btn_wrap">
              <Link to="/Work">
                <button className="action">공연사진 보러가기</button>
              </Link>
            </div>


          </section>
        
             
          <section data-aos="fade-up" className="link">
            <h2>Link</h2>

            <div className="icowrap">
              <a href="https://www.instagram.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faInstagram} />
                </div>
              </a>

              <a href="https://www.facebook.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faFacebook} />
                </div>
              </a>

              <a href="https://blog.naver.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faBloggerB} />
                </div>
              </a>

              <a href="mailto:chinamagic8@naver.com" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="600">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
              </a>
             
            </div>

            <div className="btn_wrap">
              <a className="btn action" href="https://smartstore.naver.com/chinamagic8" target="_blank">
                매직샵 바로가기
              </a>
            </div>

          </section>


        </div>
              
      </React.Fragment>
    );
  }
}

export default About;
